import { render, staticRenderFns } from "./TableSaveSettingsButton.vue?vue&type=template&id=0c94d9aa&"
import script from "./TableSaveSettingsButton.vue?vue&type=script&lang=ts&"
export * from "./TableSaveSettingsButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports